import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';
import { TrackEvent, GlobalMessage, appApi } from '@alycecom/services';
import { History } from 'history';

import { codeEpics, codeReducer } from '../modules/CodeModule';
import { productEpics, productReducer } from '../modules/ProductModule';
import { marketplaceEpics, marketplaceReducer } from '../modules/MarketplaceModule';
import { redeemEpics, redeemReducer } from '../modules/RedeemModule';
import { brandingEpics, brandingReducer } from '../modules/BrandingModule/store';
import { recipient } from '../modules/RecipientModule/store/recipient.reducer';
import recipientEpics from '../modules/RecipientModule/store/recipient.epics';
import { acceptGiftCode } from '../modules/AcceptGiftCode/store/acceptGiftCode.reducer';
import acceptGiftCodeEpics from '../modules/AcceptGiftCode/store/acceptGiftCode.epics';

import { proxyBrandingEpics } from './proxyBranding/proxyBranding.epics';
import globalSettingsReducer from './globalSettings/globalSettings.reducer';
import { geoIpCountry } from './geoIpCountry/geoIpCountry.reducer';
import { geoIpCountryEpics } from './geoIpCountry/geoIpCountry.epics';
import { branding as giftBranding } from './branding/branding.reducer';
import { brandingEpics as giftBrandingEpics } from './branding/branding.epics';
import { users } from './users/users.reducer';
import { usersEpics } from './users/users.epics';
import { countries } from './countries/countries.reducer';
import { countriesEpics } from './countries/countries.epics';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const rootReducer = (history: History<unknown>) =>
  combineReducers({
    router: connectRouter(history),
    code: codeReducer,
    recipient,
    product: productReducer,
    marketplace: marketplaceReducer,
    redeem: redeemReducer,
    globalSettings: globalSettingsReducer,
    geoIpCountry,

    branding: brandingReducer,
    giftBranding,

    users,
    countries,
    acceptGiftCode,

    [appApi.reducerPath]: appApi.reducer,

    ...(GlobalMessage.reducers as { [key: string]: unknown }),
  });

export const rootEpic = combineEpics(
  ...TrackEvent.trackEventEpics,
  ...recipientEpics,
  ...codeEpics,
  ...productEpics,
  ...marketplaceEpics,
  ...redeemEpics,
  ...GlobalMessage.epics,
  ...proxyBrandingEpics,
  ...brandingEpics,
  ...geoIpCountryEpics,
  ...giftBrandingEpics,
  ...usersEpics,
  ...acceptGiftCodeEpics,
  ...countriesEpics,
);
